module.exports = __webpack_public_path__ + "static/media/calander-icon.0858d069.svg";